import { render, staticRenderFns } from "./openJNJUser.vue?vue&type=template&id=5a12b1e0&scoped=true&"
import script from "./openJNJUser.vue?vue&type=script&lang=js&"
export * from "./openJNJUser.vue?vue&type=script&lang=js&"
import style0 from "./openJNJUser.vue?vue&type=style&index=0&id=5a12b1e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a12b1e0",
  null
  
)

export default component.exports